import styled from 'styled-components'
import { Link } from 'gatsby'

import {
  DEVICE,
  NAVIGATION_BAR_COLLAPSED_SIZE,
  NAVIGATION_MENU_EXPANDED_WIDTH_DESKTOP,
} from '../../../util/constants'

const MENU_TEXT_TRANSITION = 'opacity 0.1s ease-in 0.15s'
export const MENU_SIZE_TRANSITION_DURATION = '0.25s'

export const ExpandedMenu = styled.div`
  background-color: var(--content-background-dark-blue);
  display: flex;
  flex-direction: column;
  flex-basis: ${({ isNavMenuOpen }) =>
    isNavMenuOpen
      ? `calc(100% - ${NAVIGATION_BAR_COLLAPSED_SIZE.mobile.height}px)`
      : 0};
  transition: flex-basis ${MENU_SIZE_TRANSITION_DURATION};
  overflow-y: scroll;
  flex-shrink: 0;

  @media ${DEVICE.tabletL} {
    flex-basis: ${({ isNavMenuOpen }) =>
      isNavMenuOpen
        ? NAVIGATION_MENU_EXPANDED_WIDTH_DESKTOP -
          NAVIGATION_BAR_COLLAPSED_SIZE.desktop.width
        : 0}px;
    height: 100vh;
    transition: flex-basis ${MENU_SIZE_TRANSITION_DURATION};
    flex-direction: row;
    overflow-x: hidden;
  }
`

export const NavContainer = styled.div`
  display: block;

  @media ${DEVICE.tabletL} {
    display: flex;
    flex-direction: row;
  }
`

export const PagesList = styled.nav`
  display: flex;
  flex-direction: column;
  transition: ${({ isNavMenuOpen }) =>
    isNavMenuOpen ? MENU_TEXT_TRANSITION : 'unset'};
  opacity: ${({ isNavMenuOpen }) => (isNavMenuOpen ? 1 : 0)};
  width: 100vw;
  padding-left: 24px;

  @media ${DEVICE.tabletL} {
    flex-basis: 360px;
    padding-left: 48px;
  }
`
export const DonateBlock = styled.div`
  display: flex;
  flex-direction: column;
  transition: ${({ isNavMenuOpen }) =>
    isNavMenuOpen ? MENU_TEXT_TRANSITION : 'unset'};
  opacity: ${({ isNavMenuOpen }) => (isNavMenuOpen ? 1 : 0)};
  width: 100vw;
  padding: 27px 0 0 27px;

  @media ${DEVICE.tabletL} {
    flex-basis: 397px;
    margin-left: 57px;
    padding: 0 0 30px;
  }
`

const TEXT_LINK_COMMON = `
  font-family: 'Open Sans';
  font-style: normal;
  font-display: swap;
  user-select: none;

  :hover {
    cursor: pointer;
    color: var(--graphic-accent-purple-1);
    text-decoration-line: underline;
  }
`

export const LandingPageLink = styled(Link)`
  ${TEXT_LINK_COMMON}
  font-size: 1.8rem;
  font-weight: 400;
  margin-top: 44px;
  color: ${props =>
    props.$isActivePage
      ? 'var(--graphic-accent-purple-1)'
      : 'var(--content-background-light)'};
  text-decoration-line: ${props =>
    props.$isActivePage ? 'underline' : 'none'};

  :first-of-type {
    margin-top: 1rem;
  }

  /* TODO: This probably isn't smart, as it assumes the last item in the page list will always be Advance (a landing page) */
  :last-of-type {
    padding-bottom: 47px;
  }

  @media ${DEVICE.tabletL} {
    font-size: 2.4rem;

    :first-of-type {
      margin-top: 62px;
    }
  }
`

export const SubpageLink = styled(Link)`
  ${TEXT_LINK_COMMON}
  font-size: 1.6rem;
  line-height: 2.2rem;
  margin-top: 12px;
  padding-left: 27px;
  color: ${props =>
    props.$isActivePage
      ? 'var(--graphic-accent-purple-1)'
      : 'var(--content-background-light)'};
  text-decoration-line: ${props =>
    props.$isActivePage ? 'underline' : 'none'};

  @media ${DEVICE.tabletL} {
    font-size: 1.8rem;
    margin-top: 20px;
    padding-left: unset;
  }
`

export const DonateButton = styled(Link)`
  text-decoration-line: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  border-radius: 5px;
  width: 132px;
  height: 56px;
  font-size: 1.8rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: 0.02em;
  background: transparent;
  color: var(--content-background-light);

  :hover {
    cursor: pointer;
    background: var(--content-background-light);
    color: var(--highlight-blue);
  }

  @media ${DEVICE.tabletL} {
    font-size: 2rem;
    letter-spacing: 0.4px;
    width: 160px;
    height: 76px;
    margin-top: 60px;
  }
`

export const Helpline = styled.div`
  margin-top: 24px;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.5;
  letter-spacing: 0.4px;
  user-select: none;
  color: var(--content-background-light);

  a {
    color: var(--content-background-light);
    text-decoration-line: none;

    :hover {
      cursor: pointer;
      color: var(--graphic-accent-purple-1);
      text-decoration-line: underline;
    }
  }

  @media ${DEVICE.tabletL} {
    font-size: 2rem;
    letter-spacing: 0.4px;
  }
`

export const FollowUs = styled.span`
  margin-top: 16px;
  font-size: 1.8rem;
  line-height: 25px;
  color: var(--content-background-light);

  @media ${DEVICE.tabletL} {
    margin-top: 24px;
  }
`
